<template>
  <div class="container-fluid">
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> درخواست انصراف
          <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
        </h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-md-2 col-12"></div>
          <div v-if="ListRequest.length==0 || (ListRequest.length-1>=0 && ListRequest[ListRequest.length-1].vaziatGrp44!=null)" class="col-md-8 col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h5>
                  {{ $store.state.NameSandogh }}
                </h5>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <h6>
                  {{ 'فرم درخواست انصراف از عضویت' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right mt-5">
                <h6>
                  {{ 'مدیرعامل محترم شرکت تعاونی اعتبار' }}
                </h6>
                <br />
                <h6>
                  {{ 'با سلام' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'احتراماً اینجانب' }}</span>
                  </div>
                  <input type="text" disabled v-model="NamFam" class="form-control text-right" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'به کد ملی ' }}</span>
                  </div>
                  <input type="text" disabled v-model="CodeMeli" class="form-control text-left" aria-label="" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="text-wrap: wrap">{{ 'درخواست انصراف از آن شرکت تعاونی اعتبار را دارم ، خواهشمند است دستور فرمائید نسبت به' }} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'استرداد مانده مطالبات اینجانب  در وجه حساب به شماره ' }}</span>
                  </div>
                  <input type="number" disabled v-model="ShomareHesab" class="form-control text-center" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'بانک رفاه کارگران اقدام فرمایند.' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'در صورت تمایل علت انصراف خود را بیان فرمائید:' }}</span>
                  </div>
                  <textarea v-model="Desc" class="form-control text-right" aria-label="With textarea"></textarea>
                </div>
                <hr />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 mt-1 text-center">
                <button @click="question()" class="btn btn-submit w-100 mt-2">ثبت درخواست</button>
              </div>
            </div>
          </div>
          <div class="col-md-8 co-12">
            <div class="row">
              <div v-if="ListRequest.length-1>=0 && ListRequest[ListRequest.length-1].vaziatGrp44==null" class="alert alert-success w-100 text-dark font-weight-bold text-right">شما عضو محترم درخواست انصراف خود را در تاریخ {{ zamanInsert }} ارسال کرده اید و تا زمان تغییر وضعیت مدیر سامانه، امکان ارسال مجدد نمی باشد</div>
            </div>
          </div>
          <div class="col-md-2 col-12"></div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
export default {
  components: { NetPaCard },
  data() {
    return {
      NamFam: '',
      CodeMeli: '',
      ShomareHesab: null,
      Desc: '',
      DataAxios: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Letter/PostEnseraf',
        Token: this.$session.get('TokenNetPa'),
      },
      IsEnsraf: false,
      zamanInsert: '',
      ListRequest: [],
    }
  },
  mounted() {
    this.NamFam = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
    this.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    this.GetData()
  },
  methods: {
    question() {
      if (this.ShomareHesab == null || this.ShomareHesab == '') {
        this.$mySweetDefault('خطا', ' شماره حساب وارد نشده است', 'error', 2500)
        return
      }
      this.$SweetQustion('اطمینان از درخواست انصراف', 'آیا اطمینان دارید که از عضویت در ' + this.$store.state.NameSandogh + 'میخواهید انصراف دهید؟', 'question', 'تایید ', 'انصراف', this.CodeMeli, this.SendData, this.isNotConfirmed)
    },
    SendData() {
      this.DataAxios.ArryfildValue.NamFam = this.NamFam
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli
      this.DataAxios.ArryfildValue.Desc = this.Desc
      this.DataAxios.ArryfildValue.ShomareHesab = this.ShomareHesab + ''
      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost('عملیات موفق', 'درخواست انصراف شما با موفقیت ثبت گردید', 'success', 2000)
          }
        })
        .finally(() => {
          this.GetData()
        })
    },
    isNotConfirmed() {},
    GetData() {
      var formdata = new FormData()
      formdata.append('codemeli', this.CodeMeli)
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'Letter/GetEnseraf',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxios_GetData).then((data) => {
       if (data.count>0) {
        this.IsEnsraf = true
         this.zamanInsert = data.data[data.data.length - 1].zamanInsert
         this.ListRequest = data.data
         this.ShomareHesab=data.data[data.data.length - 1].shomareHesab
       }
       if (data.count==0) {
        this.ListRequest=[]
        this.ShomareHesab=data.data.hesabNo.trim()
        this.IsEnsraf = false
       }
      })
    },
  },
}
</script>
<style scoped>
input[type='text'],
input[type='number'],
input[type='password'],
textarea,
select {
  outline: none;
}

input {
  background: transparent;
  border: none;
  border-bottom: 1px solid #a3a3a3;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: none !important;
  border-radius: 0px !important ;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
